import {
  CraftnoteEvent,
  createCraftnoteEventBuilder,
  GlobalCraftnoteEventParameters
} from "./CraftnoteEvent.generated";
/**
* Container for all events for Authentication
*
*
* this file was auto-generated Craftnote Events Code Generator, for more info visit: https://github.com/craftnote/craftnote-events
*/
export type AuthParameters = AuthRegisterExecutedParameters | AuthLoginExecutedParameters | AuthLogoutExecutedParameters | AuthPasswordresetRequestedParameters | AuthAccountDeletedParameters;
export type AuthEvents = AuthRegisterExecutedEvent | AuthLoginExecutedEvent | AuthLogoutExecutedEvent | AuthPasswordresetRequestedEvent | AuthAccountDeletedEvent;

export interface AuthRegisterExecutedParameters {
	version: string; // version of the mobile or web app
	companyId?: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	provider: string; // the auth provider used, can be any of "apple", "facebook", "google", "password"
	tracker?: string; // name of the register tracker, equal to what we store to the ProfileTracker
	campaign?: string; // name of the campaign from adjust, resp. campaign name from utm_campaign parameter, we use this parameter in addition to the tracker parameter to allow to identify registrations with certain campaigns
}

export type AuthRegisterExecutedParametersSpecific = Omit<
	AuthRegisterExecutedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const authRegisterExecutedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','userId'];

export class AuthRegisterExecutedEventBuilder {
	constructor(private specificParameters: AuthRegisterExecutedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<AuthRegisterExecutedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			AuthRegisterExecutedParametersSpecific,
            AuthRegisterExecutedParameters,
			(params: AuthRegisterExecutedParameters) => AuthRegisterExecutedEvent
		>(this.specificParameters, authRegisterExecutedParametersGlobal, globalParams, (params) => new AuthRegisterExecutedEvent(params));
	}
}

/**
 * A user registered. This event is sent as soon as the profile of the user has been created.
 */
export class AuthRegisterExecutedEvent extends CraftnoteEvent<AuthRegisterExecutedParameters>{
  constructor(parameters: AuthRegisterExecutedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "register_register_pool"
		},
		{
			name: "iterable",
			eventName: "auth_register_executed"
		},
	]);
  }
}
export interface AuthLoginExecutedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
	provider: string; // the auth provider used, can be any of "apple", "facebook", "google", "password"
}

export type AuthLoginExecutedParametersSpecific = Omit<
	AuthLoginExecutedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const authLoginExecutedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class AuthLoginExecutedEventBuilder {
	constructor(private specificParameters: AuthLoginExecutedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<AuthLoginExecutedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			AuthLoginExecutedParametersSpecific,
            AuthLoginExecutedParameters,
			(params: AuthLoginExecutedParameters) => AuthLoginExecutedEvent
		>(this.specificParameters, authLoginExecutedParametersGlobal, globalParams, (params) => new AuthLoginExecutedEvent(params));
	}
}

/**
 * A user logged in.
 */
export class AuthLoginExecutedEvent extends CraftnoteEvent<AuthLoginExecutedParameters>{
  constructor(parameters: AuthLoginExecutedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "login_loginButton_click"
		},
		{
			name: "iterable",
			eventName: "auth_login_executed"
		},
	]);
  }
}
export interface AuthLogoutExecutedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
	isOnline: boolean; // client connection while event trigger
	networkType: string; // networkType while event trigger (LTE, WIFI, UNKNOWN)
	signalStrength?: number; // connectivity strength (between 1-5)
	uploadTime?: number; // up stream bandwidth in kByte/s
	downloadTime?: number; // down stream bandwidth in kByte/s
}

export type AuthLogoutExecutedParametersSpecific = Omit<
	AuthLogoutExecutedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const authLogoutExecutedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class AuthLogoutExecutedEventBuilder {
	constructor(private specificParameters: AuthLogoutExecutedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<AuthLogoutExecutedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			AuthLogoutExecutedParametersSpecific,
            AuthLogoutExecutedParameters,
			(params: AuthLogoutExecutedParameters) => AuthLogoutExecutedEvent
		>(this.specificParameters, authLogoutExecutedParametersGlobal, globalParams, (params) => new AuthLogoutExecutedEvent(params));
	}
}

/**
 * A user logged out.
 */
export class AuthLogoutExecutedEvent extends CraftnoteEvent<AuthLogoutExecutedParameters>{
  constructor(parameters: AuthLogoutExecutedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "logout_logout_succeeded"
		},
		{
			name: "iterable",
			eventName: "auth_logout_executed"
		},
	]);
  }
}
export interface AuthPasswordresetRequestedParameters {
	version: string; // version of the mobile or web app
}

export type AuthPasswordresetRequestedParametersSpecific = Omit<
	AuthPasswordresetRequestedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const authPasswordresetRequestedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version'];

export class AuthPasswordresetRequestedEventBuilder {
	constructor(private specificParameters: AuthPasswordresetRequestedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<AuthPasswordresetRequestedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			AuthPasswordresetRequestedParametersSpecific,
            AuthPasswordresetRequestedParameters,
			(params: AuthPasswordresetRequestedParameters) => AuthPasswordresetRequestedEvent
		>(this.specificParameters, authPasswordresetRequestedParametersGlobal, globalParams, (params) => new AuthPasswordresetRequestedEvent(params));
	}
}

/**
 * A user requested a password reset. This event is triggered when the reset is executed.
 */
export class AuthPasswordresetRequestedEvent extends CraftnoteEvent<AuthPasswordresetRequestedParameters>{
  constructor(parameters: AuthPasswordresetRequestedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "login_forgottenPasswordButton_click"
		},
		{
			name: "iterable",
			eventName: "auth_passwordreset_requested"
		},
	]);
  }
}
export interface AuthAccountDeletedParameters {
	version: string; // version of the mobile or web app
	companyId: string; // ID of the current user's company
	userId: string; // ID of the currently logged in user
}

export type AuthAccountDeletedParametersSpecific = Omit<
	AuthAccountDeletedParameters,
	'version' | 'companyId' | 'userId' | 'isOnline' | 'networkType' | 'signalStrength' | 'uploadTime' | 'downloadTime'
>;

const authAccountDeletedParametersGlobal: (keyof GlobalCraftnoteEventParameters)[] = ['version','companyId','userId'];

export class AuthAccountDeletedEventBuilder {
	constructor(private specificParameters: AuthAccountDeletedParametersSpecific) {
	}
	async build(resolve: () => Promise<GlobalCraftnoteEventParameters>): Promise<CraftnoteEvent<AuthAccountDeletedParameters>> {
		const globalParams = await resolve();
		return createCraftnoteEventBuilder<
			AuthAccountDeletedParametersSpecific,
            AuthAccountDeletedParameters,
			(params: AuthAccountDeletedParameters) => AuthAccountDeletedEvent
		>(this.specificParameters, authAccountDeletedParametersGlobal, globalParams, (params) => new AuthAccountDeletedEvent(params));
	}
}

/**
 * A user deleted his account.
 */
export class AuthAccountDeletedEvent extends CraftnoteEvent<AuthAccountDeletedParameters>{
  constructor(parameters: AuthAccountDeletedParameters){
	super(parameters);
	this.setProviders([
		{
			name: "firebase",
			eventName: "auth_account_deleted"
		},
		{
			name: "iterable",
			eventName: "auth_account_deleted"
		},
	]);
  }
}
